export default (client, defaultParams) => ({
  get: (hash) => (
    client(`/customer/${hash}`, {
      method: 'GET',
      params: {
        ...defaultParams,
      },
    })
  ),
  all: () => (
    client('/customers', {
      method: 'GET',
      params: {
        ...defaultParams,
      },
    })
  ),
  xlsx: () => (
    client('/customers/xlsx', {
      method: 'GET',
      params: {
        ...defaultParams,
      },
    })
  ),
  update: (hash, data) => (
    client(`/customer/${hash}`, {
      method: 'PUT',
      data,
      params: {
        ...defaultParams,
      },
    })
  ),
  create: (data) => (
    client('/customers', {
      method: 'POST',
      data,
      params: {
        ...defaultParams,
      },
    })
  ),

  getMessage: (k) => {
    const messages = {
    };
    return (messages[k] || k);
  },
});
